export default __webpack_public_path__ + "static/media/show-password-icon.4e2380d1.svg";